<template>
  <div style="display: flex; flex-direction: column; margin-top: 0.5em">
    <div style="display: flex; width: 250px">
      <div class="inline-effort-image" :style="imageStyle">
        <div style="width: 42px; height: 42px"></div>
      </div>
      <div>
        <div><span class="sessions-effort-text" style="cursor: pointer" @click="onGoToCommitment()">{{ commitmentMeta.name }}</span></div>
        <div>
          <div style="display: flex; flex-wrap: nowrap; align-items: center">
            Max Time Today:
            <duration-quick-settings
              style="margin-left: 0.5em;"

              :value="commitmentDailySettings.committedTimeDaily || commitment.committedTimePerDay"
              @save="onChangeCommittedTimeDailyForDateTimestamp($event)"
              :quickDurationSettings="{
                '0 min': 0 * 60,
                '5 min': 5 * 60,
                '10 min': 10 * 60,
                '15 min': 15 * 60,
                '20 min': 20 * 60,
                '25 min': 25 * 60,
                '30 min': 30 * 60,
                '45 min': 45 * 60,
                '60 min': 60 * 60,
                '90 min': 90 * 60,
                '2h': 120 * 60,
                '3h': 180 * 60,
                '4h': 240 * 60,
                '5h': 300 * 60,
                '6h': 360 * 60,
                '7h': 420 * 60,
                '8h': 480 * 60,
                '9h': 540 * 60,
                '10h': 600 * 60,
                '12h': 720 * 60,
                'no limit': 1440 * 60

              }">
              {{ commitmentDailySettings.committedTimeDaily !== undefined && !isNaN(commitmentDailySettings.committedTimeDaily) ? commitmentDailySettings.committedTimeDaily : commitment.committedTimePerDay | hoursMinutes }}
            </duration-quick-settings>
            <font-awesome-icon
              v-show="commitmentDailySettings.committedTimeDaily"
              v-tooltip="{ content: 'Delete custom setting for this day'}"
              class="inline-icon"
              :icon="['fas', 'times']"
              size="lg"
              @click="removeCommitmentDailySetting()" />
          </div>
        </div>
        <div style="display: flex; flex-wrap: false; align-items: center">
          Scheduled: <span style="margin-left: 0.5em;">{{ session_duration_today | hoursMinutes }} </span>
              <!--<br />
              <el-progress :percentage="Math.round(session_duration_today / (commitmentDailySettings.committedTimeDaily || commitment.committedTimePerDay) * 100 )" ></el-progress>-->
        </div>
        <div>
        <ProgressBar
          style="display: flex; justify-content: center"
          :value1="session_duration_today"
          :value2="session_duration_today"
          type="line-double"
          :stroke-width="10"
          :color1="tscColor"
          :color2="tscColor"
          :width="200"
          :target="commitmentDailySettings.committedTimeDaily || commitment.committedTimePerDay"
          unit="min"
          :stepSize="5"
          v-tooltip="{ content: Math.round(session_duration_today / (commitmentDailySettings.committedTimeDaily || commitment.committedTimePerDay) * 100 )  + '%'}"></ProgressBar>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import moment from '@/moment-gp'
//import ProgressBar from "@/components/Elements/ProgressBar"
import { mapActions } from 'vuex'
import DurationQuickSettings from '@/components/Elements/DurationQuickSettings'

export default {
  name: 'InlineEffort',
  props: {
    commitmentId: {
      type: String,
      required: true
    },
    commitmentMeta: {
      type: Object,
      required: true
    },
    goalId: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'all'
    },
    dateTimestamp: {
      type: Number,
      required: true
    },
    sessionItems: {
      type: Array,
      default: null
    },
    tscColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      goalMouseoverActive: false,
      effortMouseoverActive: false
    }
  },
  computed: {
    // ...mapGetters("goal", [
    //   "goal_by_id"
    // ]),

    commitment() {
      return this.$models.commitment.with({ goalId: this.goalId }).subscribeNode( this.commitmentId );
    },

    session_duration_today() {
      if (this.sessionItems && this.sessionItems.length > 0) {
        let sessionsThisCommitment = this.sessionItems
        .filter(session => session.commitmentId
          && session.commitmentId === this.commitmentId
          && session.from >= this.dateTimestamp
          && session.from < this.dateTimestamp + 86400)
        //console.log('sessionsThisCommitment', sessionsThisCommitment)
        let duration = 0
        sessionsThisCommitment.forEach(session => {
          duration += Math.min(this.dateTimestamp + 86400, session.until) - session.from
        })
        return duration
      } else {
        return 0
      }
    },

    commitmentDailySettings() {
      let commitmentDailySettings = this.$models.commitmentDailySettingsItem
        .with({
          goalId: this.goalId,
          dateString: this.dateString
          })
        .getData(this.commitmentId, true)

      // getData could return an empty object, if data is not present in state

      return commitmentDailySettings
    },

    imageStyle() {
      return {
        'backgroundImage': 'url(' + this.imageSource + ')',
        'border-color': this.tscColor//this.session.color
      }
    },
    imageSource() {
      if (this.commitment.$ready) {
        if (this.commitment.picture) {
          return this.commitment.picture
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    dateString() {
      return moment.unix(this.dateTimestamp).format("YYMMDD")
    }
  },
  methods: {
    ...mapActions('session', [
      "session_set_filterByGoalId",
      "session_set_filterByCommitmentId"
    ]),

    onChangeCommittedTimePerDay(committedTimePerDay) {
      this.$models.commitment
      .with({ goalId: this.goalId })
      .update(this.commitment.$id, { committedTimePerDay: committedTimePerDay })
    },

    onChangeCommittedTimeDailyForDateTimestamp(committedTimeDaily) {
      console.log('onChangeCommittedTimeDailyForDateTimestamp',this.goalId, this.commitmentId, this.dateTimestamp, committedTimeDaily)
      return this.$models.commitmentDailySettingsItem
      .with({
        goalId: this.goalId,
        dateString: this.dateString,
      })
      .update(this.commitmentId, {
        committedTimeDaily: committedTimeDaily
      })
    },

    removeCommitmentDailySetting() {
      this.$models.commitmentDailySettingsItem
      .with({
        goalId: this.goalId,
        dateString: this.dateString,
      })
      .remove(this.commitmentId)
    },

    onGoToCommitment() {
      this.$router.push('/goal/' + this.goalId + '/kanban')
    }

    /*onMouseoverGoal() {
      this.goalMouseoverActive = true
      setTimeout(() => {
        if (this.goalMouseoverActive === true ) { // checks if mouseout event occured during timeout
          this.session_set_filterByGoalId({ goalId: this.commitment.goalId })
        }
      }, 300)
    },
    onMouseoutGoal() {
      this.goalMouseoverActive = false
    },

    onMouseoverEffort() {
      this.effortMouseoverActive = true
      setTimeout(() => {
        if (this.effortMouseoverActive === true ) { // checks if mouseout event occured during timeout
          this.session_set_filterByCommitmentId({ commitmentId: this.commitment.commitmentId })
        }
      }, 300)
    },
    onMouseoutEffort() {
      this.effortMouseoverActive = false
    }*/
  },
  mounted() {
  },
  components: {
    //ProgressBar,
    DurationQuickSettings
  }
};
</script>
<style>
.inline-effort-image {
  width: 42px;
  height: 42px;
  margin-right: 0.5em;
  border: 1px solid white;
  cursor: pointer;
  /* display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; */

  background-position: 50% 25%;
  background-repeat: no-repeat;
  background-size: cover;
}
.inline-effort-image img {
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%
}
</style>
